import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "../../authentication/auth.service";
import { ApiServiceBase } from "../../base/api-service-base";
import { ProductScheduleVersionModel } from "../../models/reference-model/reference-general-model";

@Injectable({
    providedIn: "root",
})
export class ProductScheduleVersionService extends ApiServiceBase {
    private readonly PATH = "/system/ProductScheduleVersions";

    constructor(httpClient: HttpClient, authService: AuthService) {
        super(httpClient, authService);
    }

    public getProductScheduleVersions(): Observable<ProductScheduleVersionModel[]> {
        return this.httpGet<ProductScheduleVersionModel[]>(this.PATH, null)
            .pipe(
                map(res => res.body)
            )
    }
}